import { useMemo } from 'react'
import { FieldError, FieldValues, FormState, Path } from 'react-hook-form'

export function useFormState<K extends FieldValues>(formState: FormState<K>) {
    return useMemo(
        function () {
            return {
                isFieldDirty(name: keyof K) {
                    return name in (formState.dirtyFields as unknown as object)
                },
                isFieldValid(name: keyof K) {
                    return !formState.errors[name]?.message
                },
                getFieldError(name: string | Path<K> | keyof K) {
                    return formState.errors[name] as FieldError
                },
            }
        },
        [formState],
    )
}
